<template>
      <v-footer color="black" dark app absolute class="caption white--text">
      <div class="box-footer">
        <div class="left-element">

          <h4 class="footer">
              Empresa
          </h4>

        <v-dialog v-model="politica" width="80%">

          <template v-slot:activator="{ on }">
            <v-btn text small dark v-on="on"
            class="button-footer">
              <v-icon class="mdi-chevron-right subtitle-1">
                mdi-chevron-right
              </v-icon>
              {{ $t('footer[0].politica')}}
            </v-btn>
          </template>
          <politica-privacidad />
        </v-dialog>

        <v-dialog v-model="condiciones" width="80%">

          <template v-slot:activator="{ on }">
            <v-btn color=""
            class="button-footer"
            text small dark v-on="on">
              <v-icon class="mdi-chevron-right subtitle-1">
                mdi-chevron-right
              </v-icon>
              {{ $t('footer[0].condicions')}}
            </v-btn>
          </template>
          <condiciones-uso />
        </v-dialog>
         
        <div class="field-footer">
          <a href="tel:935880344" class="nolink">
            <v-icon class="mdi-chevron-right subtitle-1">
              mdi-phone
            </v-icon>
            Tel. 93 588 03 44
          </a>
        </div>

        <div class="field-footer">
          <a :href="`/${$i18n.locale}/contacte`" class="nolink email">
            <v-icon class="mdi-chevron-right subtitle-1">
              mdi-email-outline
            </v-icon> 
            packetgrup@packetgrup.com
          </a>
        </div>
        </div>

        <div class="right-element flex copyright">
          <div class="ma-1 d-flex last-tense-footer">
            &copy; 
             {{ $t('footer[0].copyright')}} {{ new Date().getFullYear() }}
          </div>
        </div>

        <div class="mobile">
          <div class="mobile-telefon">
            <a href="tel:935880344">
              93 588 03 44
            </a>
          </div>
          <div class="mobile-contact">
            <a :href="`/${$i18n.locale}/contacte`">
              packetgrup@packetgrup.com
            </a>
          </div>
        </div>
      
      </div>

    </v-footer>
</template>

<script>

import politicaPrivacidad from '@/components/elements/politicaPrivacidad.vue'
import condicionesUso from '@/components/elements/condicionesUso.vue'

export default {
    name: 'Footer',
    props: {
    },
    components: {
      politicaPrivacidad,
      condicionesUso
    },
    data () {
      return {
        fecha: '',
        condiciones: false,
        politica: false
      }
    }
}
</script>

<style scoped lang="scss">


  h4.footer {
    font-size: 14px;
    font-weight: bold;
    padding-left: 15px;
    padding-bottom: 4px;
    text-transform: uppercase;
  }

  .nolink {
    color: gray !important;
    text-decoration: none;
    font-size: 1.2em;
  }

  .v-icon{
    color: rgb(39, 39, 39);
    margin-right: 4px;
  }

  .element-left {
    align-items: flex-start;
  }

  .field-footer {    
    padding: 5px 11px 0px 15px;
    font-size: 0.90em;
    color: gray;

    i {
      color: gray;
      padding-bottom: 5px;
      stroke: black;
    }
  }
  

</style>
